import { Loader } from "shared/components/Loader";
import moment from "moment";
import { useAuthContext } from "providers/Auth";
import { IconButton, IconButtonSize } from "shared/components";
import { RefreshCCW02 } from "untitledui-js-base";
import { cx } from "shared/utils";
import { useMedia } from "shared/providers";

type PropertyManagementSystemSync = {
  lastSuccessSyncedAt?: string;
  handleRequestSync?: () => void;
  isSyncing?: boolean;
  withDivider?: boolean;
};

export const PropertyManagementSystemSync = ({
  lastSuccessSyncedAt,
  handleRequestSync,
  isSyncing,
  withDivider
}: PropertyManagementSystemSync) => {
  const { type } = useAuthContext();

  const { isMobile } = useMedia();

  if (!type.isPMS) return null;

  const formatDate = (date?: string) => {
    if (!date) return "N/A";

    return moment(date).format("MMM DD, YYYY, h:mm A");
  };

  return (
    <div
      className={cx(
        "flex grow items-center gap-2",
        withDivider && "border-l border-alpha-40 pl-4"
      )}
    >
      {isSyncing ? (
        <Loader size={32} />
      ) : (
        <IconButton
          className="shrink-0"
          Icon={RefreshCCW02}
          onClick={handleRequestSync}
          size={isMobile ? IconButtonSize.BASE : IconButtonSize.SM}
        />
      )}

      <p className="text-xs font-medium text-content-200 md:block hidden">
        Last sync: {formatDate(lastSuccessSyncedAt)}
      </p>
    </div>
  );
};
